// src/types/contents.ts
var BuilderType = /* @__PURE__ */ ((BuilderType2) => {
  BuilderType2["EXTENSION"] = "extension";
  BuilderType2["WEB"] = "web";
  BuilderType2["ALL"] = "all";
  return BuilderType2;
})(BuilderType || {});
var ContentActionsItemType = /* @__PURE__ */ ((ContentActionsItemType2) => {
  ContentActionsItemType2["STEP_GOTO"] = "step-goto";
  ContentActionsItemType2["FLOW_DISMIS"] = "flow-dismis";
  ContentActionsItemType2["LAUNCHER_DISMIS"] = "launcher-dismis";
  ContentActionsItemType2["CHECKLIST_DISMIS"] = "checklist-dismis";
  ContentActionsItemType2["BANNER_DISMIS"] = "banner-dismis";
  ContentActionsItemType2["FLOW_START"] = "flow-start";
  ContentActionsItemType2["PAGE_NAVIGATE"] = "page-navigate";
  ContentActionsItemType2["JAVASCRIPT_EVALUATE"] = "javascript-evaluate";
  return ContentActionsItemType2;
})(ContentActionsItemType || {});
var ContentDataType = /* @__PURE__ */ ((ContentDataType2) => {
  ContentDataType2["CHECKLIST"] = "checklist";
  ContentDataType2["FLOW"] = "flow";
  ContentDataType2["LAUNCHER"] = "launcher";
  ContentDataType2["BANNER"] = "banner";
  ContentDataType2["TRACKER"] = "tracker";
  ContentDataType2["RESOURCE_CENTER"] = "resource-center";
  ContentDataType2["ANNOUNCEMENT"] = "announcement";
  return ContentDataType2;
})(ContentDataType || {});
var ContentTypeName = /* @__PURE__ */ ((ContentTypeName2) => {
  ContentTypeName2["CHECKLISTS"] = "checklists";
  ContentTypeName2["FLOWS"] = "flows";
  ContentTypeName2["LAUNCHERS"] = "launchers";
  ContentTypeName2["RESOURCE_CENTERS"] = "resource-centers";
  ContentTypeName2["BANNERS"] = "banners";
  ContentTypeName2["TRACKERS"] = "trackers";
  ContentTypeName2["ANNOUNCEMENTS"] = "announcements";
  return ContentTypeName2;
})(ContentTypeName || {});
var LauncherDataType = /* @__PURE__ */ ((LauncherDataType2) => {
  LauncherDataType2["BEACON"] = "beacon";
  LauncherDataType2["ICON"] = "icon";
  LauncherDataType2["HIDDEN"] = "hidden";
  LauncherDataType2["BUTTON"] = "button";
  return LauncherDataType2;
})(LauncherDataType || {});
var ModalPosition = /* @__PURE__ */ ((ModalPosition2) => {
  ModalPosition2["LeftTop"] = "leftTop";
  ModalPosition2["CenterTop"] = "centerTop";
  ModalPosition2["RightTop"] = "rightTop";
  ModalPosition2["LeftCenter"] = "leftCenter";
  ModalPosition2["Center"] = "center";
  ModalPosition2["RightCenter"] = "rightCenter";
  ModalPosition2["LeftBottom"] = "leftBottom";
  ModalPosition2["CenterBottom"] = "centerBottom";
  ModalPosition2["RightBottom"] = "rightBottom";
  return ModalPosition2;
})(ModalPosition || {});
var StepContentType = /* @__PURE__ */ ((StepContentType2) => {
  StepContentType2["TOOLTIP"] = "tooltip";
  StepContentType2["MODAL"] = "modal";
  StepContentType2["HIDDEN"] = "hidden";
  StepContentType2["BUBBLE"] = "bubble";
  return StepContentType2;
})(StepContentType || {});

// src/types/theme.ts
var ThemeDetailPreviewType = /* @__PURE__ */ ((ThemeDetailPreviewType2) => {
  ThemeDetailPreviewType2["TOOLTIP"] = "tooltip";
  ThemeDetailPreviewType2["MODAL"] = "modal";
  ThemeDetailPreviewType2["BUBBLE"] = "bubble";
  ThemeDetailPreviewType2["BANNER"] = "banner";
  ThemeDetailPreviewType2["LAUNCHER_ICON"] = "launcher-icon";
  ThemeDetailPreviewType2["LAUNCHER_BEACON"] = "launcher-beacon";
  ThemeDetailPreviewType2["LAUNCHER_BUTTON"] = "launcher-button";
  ThemeDetailPreviewType2["CHECKLIST"] = "checklist";
  ThemeDetailPreviewType2["CHECKLIST_LAUNCHER"] = "checklist-launcher";
  ThemeDetailPreviewType2["NPS"] = "nps";
  ThemeDetailPreviewType2["RESOURCE_CENTER"] = "resource-center";
  ThemeDetailPreviewType2["RESOURCE_CENTER_LAUNCHER"] = "resource-center-launcher";
  ThemeDetailPreviewType2["ANNOUNCEMENT"] = "announcement";
  return ThemeDetailPreviewType2;
})(ThemeDetailPreviewType || {});

// src/types/theme-settings.ts
var ProgressBarType = /* @__PURE__ */ ((ProgressBarType2) => {
  ProgressBarType2["FULL_WIDTH"] = "full-width";
  ProgressBarType2["NARROW"] = "narrow";
  ProgressBarType2["CHAIN_ROUNDED"] = "chain-rounded";
  ProgressBarType2["CHAIN_SQUARED"] = "chain-squared";
  ProgressBarType2["DOTS"] = "dots";
  ProgressBarType2["NUMBERED"] = "numbered";
  return ProgressBarType2;
})(ProgressBarType || {});
var ProgressBarPosition = /* @__PURE__ */ ((ProgressBarPosition2) => {
  ProgressBarPosition2["TOP"] = "top";
  ProgressBarPosition2["BOTTOM"] = "bottom";
  return ProgressBarPosition2;
})(ProgressBarPosition || {});
var AvatarType = /* @__PURE__ */ ((AvatarType2) => {
  AvatarType2["CARTOON"] = "cartoon";
  AvatarType2["UPLOAD"] = "upload";
  AvatarType2["URL"] = "url";
  AvatarType2["NONE"] = "none";
  return AvatarType2;
})(AvatarType || {});
var MissingTooltipTargetBehavior = /* @__PURE__ */ ((MissingTooltipTargetBehavior2) => {
  MissingTooltipTargetBehavior2["AUTO_DISMISS"] = "auto-dismiss";
  MissingTooltipTargetBehavior2["USE_BUBBLE"] = "use-bubble";
  return MissingTooltipTargetBehavior2;
})(MissingTooltipTargetBehavior || {});
var ModalBackdropClickBehavior = /* @__PURE__ */ ((ModalBackdropClickBehavior2) => {
  ModalBackdropClickBehavior2["DO_NOTHING"] = "do-nothing";
  ModalBackdropClickBehavior2["DISMISS_FLOW"] = "dismiss-flow";
  return ModalBackdropClickBehavior2;
})(ModalBackdropClickBehavior || {});

// src/types/attribute.ts
var BizAttributeTypes = /* @__PURE__ */ ((BizAttributeTypes2) => {
  BizAttributeTypes2[BizAttributeTypes2["Nil"] = 0] = "Nil";
  BizAttributeTypes2[BizAttributeTypes2["Number"] = 1] = "Number";
  BizAttributeTypes2[BizAttributeTypes2["String"] = 2] = "String";
  BizAttributeTypes2[BizAttributeTypes2["Boolean"] = 3] = "Boolean";
  BizAttributeTypes2[BizAttributeTypes2["List"] = 4] = "List";
  BizAttributeTypes2[BizAttributeTypes2["DateTime"] = 5] = "DateTime";
  BizAttributeTypes2[BizAttributeTypes2["RandomAB"] = 6] = "RandomAB";
  BizAttributeTypes2[BizAttributeTypes2["RandomNumber"] = 7] = "RandomNumber";
  return BizAttributeTypes2;
})(BizAttributeTypes || {});
var AttributeBizTypes = /* @__PURE__ */ ((AttributeBizTypes2) => {
  AttributeBizTypes2[AttributeBizTypes2["Nil"] = 0] = "Nil";
  AttributeBizTypes2[AttributeBizTypes2["User"] = 1] = "User";
  AttributeBizTypes2[AttributeBizTypes2["Company"] = 2] = "Company";
  AttributeBizTypes2[AttributeBizTypes2["Membership"] = 3] = "Membership";
  AttributeBizTypes2[AttributeBizTypes2["Event"] = 4] = "Event";
  return AttributeBizTypes2;
})(AttributeBizTypes || {});
var AttributeWriteOperation = /* @__PURE__ */ ((AttributeWriteOperation2) => {
  AttributeWriteOperation2["Set"] = "set";
  AttributeWriteOperation2["SetOnce"] = "set_once";
  AttributeWriteOperation2["Add"] = "add";
  AttributeWriteOperation2["Union"] = "union";
  AttributeWriteOperation2["Remove"] = "remove";
  return AttributeWriteOperation2;
})(AttributeWriteOperation || {});
var AttributeDataType = /* @__PURE__ */ ((AttributeDataType2) => {
  AttributeDataType2[AttributeDataType2["Number"] = 1] = "Number";
  AttributeDataType2[AttributeDataType2["String"] = 2] = "String";
  AttributeDataType2[AttributeDataType2["Boolean"] = 3] = "Boolean";
  AttributeDataType2[AttributeDataType2["List"] = 4] = "List";
  AttributeDataType2[AttributeDataType2["DateTime"] = 5] = "DateTime";
  AttributeDataType2[AttributeDataType2["RandomAB"] = 6] = "RandomAB";
  AttributeDataType2[AttributeDataType2["RandomNumber"] = 7] = "RandomNumber";
  return AttributeDataType2;
})(AttributeDataType || {});
var CompanyAttributes = /* @__PURE__ */ ((CompanyAttributes2) => {
  CompanyAttributes2["NAME"] = "name";
  CompanyAttributes2["FIRST_SEEN_AT"] = "first_seen_at";
  CompanyAttributes2["LAST_SEEN_AT"] = "last_seen_at";
  CompanyAttributes2["SIGNED_UP_AT"] = "signed_up_at";
  return CompanyAttributes2;
})(CompanyAttributes || {});
var UserAttributes = /* @__PURE__ */ ((UserAttributes2) => {
  UserAttributes2["EMAIL"] = "email";
  UserAttributes2["NAME"] = "name";
  UserAttributes2["FIRST_SEEN_AT"] = "first_seen_at";
  UserAttributes2["LAST_SEEN_AT"] = "last_seen_at";
  UserAttributes2["SIGNED_UP_AT"] = "signed_up_at";
  UserAttributes2["LOCALE_CODE"] = "locale_code";
  return UserAttributes2;
})(UserAttributes || {});
var BizEvents = /* @__PURE__ */ ((BizEvents2) => {
  BizEvents2["PAGE_VIEWED"] = "page_viewed";
  BizEvents2["FLOW_STEP_SEEN"] = "flow_step_seen";
  BizEvents2["FLOW_COMPLETED"] = "flow_completed";
  BizEvents2["FLOW_STARTED"] = "flow_started";
  BizEvents2["FLOW_ENDED"] = "flow_ended";
  BizEvents2["TOOLTIP_TARGET_MISSING"] = "tooltip_target_missing";
  BizEvents2["FLOW_STEP_COMPLETED"] = "flow_step_completed";
  BizEvents2["LAUNCHER_ACTIVATED"] = "launcher_activated";
  BizEvents2["LAUNCHER_DISMISSED"] = "launcher_dismissed";
  BizEvents2["LAUNCHER_SEEN"] = "launcher_seen";
  BizEvents2["CHECKLIST_COMPLETED"] = "checklist_completed";
  BizEvents2["CHECKLIST_DISMISSED"] = "checklist_dismissed";
  BizEvents2["CHECKLIST_HIDDEN"] = "checklist_hidden";
  BizEvents2["CHECKLIST_SEEN"] = "checklist_seen";
  BizEvents2["CHECKLIST_STARTED"] = "checklist_started";
  BizEvents2["CHECKLIST_TASK_CLICKED"] = "checklist_task_clicked";
  BizEvents2["CHECKLIST_TASK_COMPLETED"] = "checklist_task_completed";
  BizEvents2["BANNER_SEEN"] = "banner_seen";
  BizEvents2["BANNER_DISMISSED"] = "banner_dismissed";
  BizEvents2["RESOURCE_CENTER_STARTED"] = "resource_center_started";
  BizEvents2["RESOURCE_CENTER_OPENED"] = "resource_center_opened";
  BizEvents2["RESOURCE_CENTER_CLOSED"] = "resource_center_closed";
  BizEvents2["RESOURCE_CENTER_CLICKED"] = "resource_center_clicked";
  BizEvents2["RESOURCE_CENTER_DISMISSED"] = "resource_center_dismissed";
  BizEvents2["EVENT_TRACKER_COMPLETED"] = "event_tracker_completed";
  BizEvents2["QUESTION_ANSWERED"] = "question_answered";
  BizEvents2["ANNOUNCEMENT_SEEN"] = "announcement_seen";
  return BizEvents2;
})(BizEvents || {});
var EventAttributes = /* @__PURE__ */ ((EventAttributes2) => {
  EventAttributes2["FLOW_ID"] = "flow_id";
  EventAttributes2["FLOW_NAME"] = "flow_name";
  EventAttributes2["FLOW_SESSION_ID"] = "flow_session_id";
  EventAttributes2["FLOW_START_REASON"] = "flow_start_reason";
  EventAttributes2["FLOW_END_REASON"] = "flow_end_reason";
  EventAttributes2["FLOW_STEP_ID"] = "flow_step_id";
  EventAttributes2["FLOW_STEP_CVID"] = "flow_step_cvid";
  EventAttributes2["FLOW_STEP_NAME"] = "flow_step_name";
  EventAttributes2["FLOW_STEP_NUMBER"] = "flow_step_number";
  EventAttributes2["FLOW_STEP_PROGRESS"] = "flow_step_progress";
  EventAttributes2["FLOW_VERSION_ID"] = "flow_version_id";
  EventAttributes2["FLOW_VERSION_NUMBER"] = "flow_version_number";
  EventAttributes2["LAUNCHER_ID"] = "launcher_id";
  EventAttributes2["LAUNCHER_NAME"] = "launcher_name";
  EventAttributes2["LAUNCHER_SESSION_ID"] = "launcher_session_id";
  EventAttributes2["LAUNCHER_START_REASON"] = "launcher_start_reason";
  EventAttributes2["LAUNCHER_END_REASON"] = "launcher_end_reason";
  EventAttributes2["LAUNCHER_VERSION_ID"] = "launcher_version_id";
  EventAttributes2["LAUNCHER_VERSION_NUMBER"] = "launcher_version_number";
  EventAttributes2["CHECKLIST_ID"] = "checklist_id";
  EventAttributes2["CHECKLIST_NAME"] = "checklist_name";
  EventAttributes2["CHECKLIST_SESSION_ID"] = "checklist_session_id";
  EventAttributes2["CHECKLIST_START_REASON"] = "checklist_start_reason";
  EventAttributes2["CHECKLIST_END_REASON"] = "checklist_end_reason";
  EventAttributes2["CHECKLIST_VERSION_ID"] = "checklist_version_id";
  EventAttributes2["CHECKLIST_VERSION_NUMBER"] = "checklist_version_number";
  EventAttributes2["CHECKLIST_TASK_CVID"] = "checklist_task_cvid";
  EventAttributes2["CHECKLIST_TASK_ID"] = "checklist_task_id";
  EventAttributes2["CHECKLIST_TASK_NAME"] = "checklist_task_name";
  EventAttributes2["BANNER_ID"] = "banner_id";
  EventAttributes2["BANNER_NAME"] = "banner_name";
  EventAttributes2["BANNER_SESSION_ID"] = "banner_session_id";
  EventAttributes2["BANNER_END_REASON"] = "banner_end_reason";
  EventAttributes2["BANNER_VERSION_ID"] = "banner_version_id";
  EventAttributes2["BANNER_VERSION_NUMBER"] = "banner_version_number";
  EventAttributes2["RESOURCE_CENTER_ID"] = "resource_center_id";
  EventAttributes2["RESOURCE_CENTER_NAME"] = "resource_center_name";
  EventAttributes2["RESOURCE_CENTER_SESSION_ID"] = "resource_center_session_id";
  EventAttributes2["RESOURCE_CENTER_START_REASON"] = "resource_center_start_reason";
  EventAttributes2["RESOURCE_CENTER_END_REASON"] = "resource_center_end_reason";
  EventAttributes2["RESOURCE_CENTER_VERSION_ID"] = "resource_center_version_id";
  EventAttributes2["RESOURCE_CENTER_VERSION_NUMBER"] = "resource_center_version_number";
  EventAttributes2["RESOURCE_CENTER_BLOCK_ID"] = "resource_center_block_id";
  EventAttributes2["RESOURCE_CENTER_BLOCK_NAME"] = "resource_center_block_name";
  EventAttributes2["RESOURCE_CENTER_TAB_ID"] = "resource_center_tab_id";
  EventAttributes2["RESOURCE_CENTER_TAB_NAME"] = "resource_center_tab_name";
  EventAttributes2["EVENT_TRACKER_ID"] = "event_tracker_id";
  EventAttributes2["EVENT_TRACKER_NAME"] = "event_tracker_name";
  EventAttributes2["EVENT_TRACKER_VERSION_ID"] = "event_tracker_version_id";
  EventAttributes2["EVENT_TRACKER_VERSION_NUMBER"] = "event_tracker_version_number";
  EventAttributes2["ANNOUNCEMENT_ID"] = "announcement_id";
  EventAttributes2["ANNOUNCEMENT_NAME"] = "announcement_name";
  EventAttributes2["ANNOUNCEMENT_VERSION_ID"] = "announcement_version_id";
  EventAttributes2["ANNOUNCEMENT_VERSION_NUMBER"] = "announcement_version_number";
  EventAttributes2["ANNOUNCEMENT_LEVEL"] = "announcement_level";
  EventAttributes2["ANNOUNCEMENT_SOURCE"] = "announcement_source";
  EventAttributes2["PAGE_URL"] = "page_url";
  EventAttributes2["VIEWPORT_WIDTH"] = "viewport_width";
  EventAttributes2["VIEWPORT_HEIGHT"] = "viewport_height";
  EventAttributes2["LOCALE_CODE"] = "locale_code";
  EventAttributes2["LIST_ANSWER"] = "list_answer";
  EventAttributes2["NUMBER_ANSWER"] = "number_answer";
  EventAttributes2["QUESTION_CVID"] = "question_cvid";
  EventAttributes2["QUESTION_NAME"] = "question_name";
  EventAttributes2["QUESTION_TYPE"] = "question_type";
  EventAttributes2["TEXT_ANSWER"] = "text_answer";
  return EventAttributes2;
})(EventAttributes || {});

// src/types/config.ts
var ContentConditionLogic = /* @__PURE__ */ ((ContentConditionLogic2) => {
  ContentConditionLogic2["SEEN"] = "seen";
  ContentConditionLogic2["UNSEEN"] = "unseen";
  ContentConditionLogic2["COMPLETED"] = "completed";
  ContentConditionLogic2["UNCOMPLETED"] = "uncompleted";
  ContentConditionLogic2["ACTIVED"] = "actived";
  ContentConditionLogic2["UNACTIVED"] = "unactived";
  return ContentConditionLogic2;
})(ContentConditionLogic || {});
var ContentPriority = /* @__PURE__ */ ((ContentPriority2) => {
  ContentPriority2["HIGHEST"] = "highest";
  ContentPriority2["HIGH"] = "high";
  ContentPriority2["MEDIUM"] = "medium";
  ContentPriority2["LOW"] = "low";
  ContentPriority2["LOWEST"] = "lowest";
  return ContentPriority2;
})(ContentPriority || {});
var ElementConditionLogic = /* @__PURE__ */ ((ElementConditionLogic2) => {
  ElementConditionLogic2["PRESENT"] = "present";
  ElementConditionLogic2["UNPRESENT"] = "unpresent";
  ElementConditionLogic2["DISABLED"] = "disabled";
  ElementConditionLogic2["UNDISABLED"] = "undisabled";
  ElementConditionLogic2["CLICKED"] = "clicked";
  ElementConditionLogic2["UNCLICKED"] = "unclicked";
  return ElementConditionLogic2;
})(ElementConditionLogic || {});
var Frequency = /* @__PURE__ */ ((Frequency2) => {
  Frequency2["ONCE"] = "once";
  Frequency2["MULTIPLE"] = "multiple";
  Frequency2["UNLIMITED"] = "unlimited";
  return Frequency2;
})(Frequency || {});
var FrequencyUnits = /* @__PURE__ */ ((FrequencyUnits2) => {
  FrequencyUnits2["DAYES"] = "days";
  FrequencyUnits2["HOURS"] = "hours";
  FrequencyUnits2["SECONDS"] = "seconds";
  FrequencyUnits2["MINUTES"] = "minutes";
  return FrequencyUnits2;
})(FrequencyUnits || {});
var RulesType = /* @__PURE__ */ ((RulesType2) => {
  RulesType2["USER_ATTR"] = "user-attr";
  RulesType2["CURRENT_PAGE"] = "current-page";
  RulesType2["EVENT"] = "event";
  RulesType2["SEGMENT"] = "segment";
  RulesType2["CONTENT"] = "content";
  RulesType2["ELEMENT"] = "element";
  RulesType2["TEXT_INPUT"] = "text-input";
  RulesType2["TEXT_FILL"] = "text-fill";
  RulesType2["TIME"] = "time";
  RulesType2["GROUP"] = "group";
  RulesType2["WAIT"] = "wait";
  RulesType2["TASK_IS_CLICKED"] = "task-is-clicked";
  RulesType2["EVENT_ATTR"] = "event-attr";
  return RulesType2;
})(RulesType || {});
var EventCountLogic = /* @__PURE__ */ ((EventCountLogic2) => {
  EventCountLogic2["AT_LEAST"] = "atLeast";
  EventCountLogic2["AT_MOST"] = "atMost";
  EventCountLogic2["EXACTLY"] = "exactly";
  EventCountLogic2["BETWEEN"] = "between";
  return EventCountLogic2;
})(EventCountLogic || {});
var EventTimeLogic = /* @__PURE__ */ ((EventTimeLogic2) => {
  EventTimeLogic2["IN_THE_LAST"] = "inTheLast";
  EventTimeLogic2["MORE_THAN"] = "moreThan";
  EventTimeLogic2["BETWEEN"] = "between";
  EventTimeLogic2["AT_ANY_POINT_IN_TIME"] = "atAnyPointInTime";
  return EventTimeLogic2;
})(EventTimeLogic || {});
var EventTimeUnit = /* @__PURE__ */ ((EventTimeUnit2) => {
  EventTimeUnit2["SECONDS"] = "seconds";
  EventTimeUnit2["MINUTES"] = "minutes";
  EventTimeUnit2["HOURS"] = "hours";
  EventTimeUnit2["DAYS"] = "days";
  return EventTimeUnit2;
})(EventTimeUnit || {});
var EventScope = /* @__PURE__ */ ((EventScope2) => {
  EventScope2["BY_CURRENT_USER_IN_ANY_COMPANY"] = "byCurrentUserInAnyCompany";
  EventScope2["BY_CURRENT_USER_IN_CURRENT_COMPANY"] = "byCurrentUserInCurrentCompany";
  EventScope2["BY_ANY_USER_IN_CURRENT_COMPANY"] = "byAnyUserInCurrentCompany";
  return EventScope2;
})(EventScope || {});
var StringConditionLogic = /* @__PURE__ */ ((StringConditionLogic2) => {
  StringConditionLogic2["IS"] = "is";
  StringConditionLogic2["NOT"] = "not";
  StringConditionLogic2["CONTAINS"] = "contains";
  StringConditionLogic2["NOT_CONTAIN"] = "notContain";
  StringConditionLogic2["STARTS_WITH"] = "startsWith";
  StringConditionLogic2["ENDS_WITH"] = "endsWith";
  StringConditionLogic2["MATCH"] = "match";
  StringConditionLogic2["UNMATCH"] = "unmatch";
  StringConditionLogic2["ANY"] = "any";
  StringConditionLogic2["EMPTY"] = "empty";
  return StringConditionLogic2;
})(StringConditionLogic || {});

// src/types/segment.ts
var SegmentDataTypes = /* @__PURE__ */ ((SegmentDataTypes2) => {
  SegmentDataTypes2[SegmentDataTypes2["ALL"] = 1] = "ALL";
  SegmentDataTypes2[SegmentDataTypes2["CONDITION"] = 2] = "CONDITION";
  SegmentDataTypes2[SegmentDataTypes2["MANUAL"] = 3] = "MANUAL";
  return SegmentDataTypes2;
})(SegmentDataTypes || {});

// src/types/common.ts
var SDKSettingsMode = /* @__PURE__ */ ((SDKSettingsMode2) => {
  SDKSettingsMode2["NORMAL"] = "normal";
  SDKSettingsMode2["PREVIEW"] = "preview";
  return SDKSettingsMode2;
})(SDKSettingsMode || {});

// src/types/sdk.ts
var contentEndReason = /* @__PURE__ */ ((contentEndReason2) => {
  contentEndReason2["USER_CLOSED"] = "user_closed";
  contentEndReason2["ACTION"] = "action";
  contentEndReason2["REPLACED"] = "replaced";
  contentEndReason2["TOOLTIP_TARGET_MISSING"] = "tooltip_target_missing";
  contentEndReason2["SYSTEM_CLOSED"] = "system_closed";
  contentEndReason2["AUTO_DISMISSED"] = "auto_dismissed";
  contentEndReason2["CONTENT_NOT_FOUND"] = "content_not_found";
  contentEndReason2["SESSION_TIMEOUT"] = "session_timeout";
  contentEndReason2["URL_START_CLOSED"] = "url_start_closed";
  contentEndReason2["USER_STARTED_OTHER_CONTENT"] = "user_started_other_content";
  contentEndReason2["PROGRAM_STARTED_OTHER_CONTENT"] = "program_started_other_content";
  contentEndReason2["STEP_NOT_FOUND"] = "step_not_found";
  contentEndReason2["UNPUBLISHED_CONTENT"] = "unpublished_content";
  contentEndReason2["END_FROM_PROGRAM"] = "end_from_program";
  contentEndReason2["LAUNCHER_DEACTIVATED"] = "launcher_deactivated";
  contentEndReason2["CLOSE_BUTTON_DISMISS"] = "close_button_dismiss";
  contentEndReason2["BACKDROP_DISMISS"] = "backdrop_dismiss";
  contentEndReason2["DISMISS_BUTTON"] = "dismiss_button";
  contentEndReason2["TRIGGER_DISMISS"] = "trigger_dismiss";
  contentEndReason2["ACTION_DISMISS"] = "action_dismiss";
  contentEndReason2["STORE_NOT_FOUND"] = "store_not_found";
  contentEndReason2["ADMIN_ENDED"] = "admin_ended";
  return contentEndReason2;
})(contentEndReason || {});
var contentStartReason = /* @__PURE__ */ ((contentStartReason2) => {
  contentStartReason2["START_FROM_CONDITION"] = "start_from_condition";
  contentStartReason2["START_FROM_URL"] = "start_from_url";
  contentStartReason2["START_FROM_SESSION"] = "start_from_session";
  contentStartReason2["START_FROM_MANUAL"] = "start_from_manual";
  contentStartReason2["START_FROM_PROGRAM"] = "start_from_program";
  contentStartReason2["START_FROM_CONTENT_ID"] = "start_from_content_id";
  contentStartReason2["START_FROM_ACTION"] = "start_from_action";
  return contentStartReason2;
})(contentStartReason || {});

// src/types/usertour.ts
var usertour_exports = {};

// src/types/launcher.ts
var LauncherTriggerElement = /* @__PURE__ */ ((LauncherTriggerElement2) => {
  LauncherTriggerElement2["LAUNCHER"] = "launcher";
  LauncherTriggerElement2["TARGET"] = "target";
  LauncherTriggerElement2["TARGET_OR_LAUNCHER"] = "target-or-launcher";
  return LauncherTriggerElement2;
})(LauncherTriggerElement || {});
var LauncherActionType = /* @__PURE__ */ ((LauncherActionType2) => {
  LauncherActionType2["SHOW_TOOLTIP"] = "show-tooltip";
  LauncherActionType2["PERFORM_ACTION"] = "perform-action";
  return LauncherActionType2;
})(LauncherActionType || {});
var LauncherTriggerEvent = /* @__PURE__ */ ((LauncherTriggerEvent2) => {
  LauncherTriggerEvent2["CLICKED"] = "clicked";
  LauncherTriggerEvent2["HOVERED"] = "hovered";
  return LauncherTriggerEvent2;
})(LauncherTriggerEvent || {});
var LauncherPositionType = /* @__PURE__ */ ((LauncherPositionType2) => {
  LauncherPositionType2["TARGET"] = "target";
  LauncherPositionType2["LAUNCHER"] = "launcher";
  return LauncherPositionType2;
})(LauncherPositionType || {});
var LauncherIconSource = /* @__PURE__ */ ((LauncherIconSource2) => {
  LauncherIconSource2["NONE"] = "none";
  LauncherIconSource2["BUILTIN"] = "builtin";
  LauncherIconSource2["UPLOAD"] = "upload";
  LauncherIconSource2["URL"] = "url";
  LauncherIconSource2["INHERIT"] = "inherit";
  return LauncherIconSource2;
})(LauncherIconSource || {});

// src/types/banner.ts
var BannerEmbedPlacement = /* @__PURE__ */ ((BannerEmbedPlacement2) => {
  BannerEmbedPlacement2["TOP_OF_PAGE"] = "top-of-page";
  BannerEmbedPlacement2["BOTTOM_OF_PAGE"] = "bottom-of-page";
  BannerEmbedPlacement2["TOP_OF_CONTAINER_ELEMENT"] = "top-of-container-element";
  BannerEmbedPlacement2["BOTTOM_OF_CONTAINER_ELEMENT"] = "bottom-of-container-element";
  BannerEmbedPlacement2["IMMEDIATELY_BEFORE_ELEMENT"] = "immediately-before-element";
  BannerEmbedPlacement2["IMMEDIATELY_AFTER_ELEMENT"] = "immediately-after-element";
  return BannerEmbedPlacement2;
})(BannerEmbedPlacement || {});

// src/types/checklist.ts
var ChecklistInitialDisplay = /* @__PURE__ */ ((ChecklistInitialDisplay2) => {
  ChecklistInitialDisplay2["EXPANDED"] = "expanded";
  ChecklistInitialDisplay2["BUTTON"] = "button";
  return ChecklistInitialDisplay2;
})(ChecklistInitialDisplay || {});
var ChecklistCompletionOrder = /* @__PURE__ */ ((ChecklistCompletionOrder2) => {
  ChecklistCompletionOrder2["ANY"] = "any";
  ChecklistCompletionOrder2["ORDERED"] = "ordered";
  return ChecklistCompletionOrder2;
})(ChecklistCompletionOrder || {});

// src/types/resource-center.ts
var ResourceCenterBlockType = /* @__PURE__ */ ((ResourceCenterBlockType2) => {
  ResourceCenterBlockType2["ACTION"] = "action";
  ResourceCenterBlockType2["RICH_TEXT"] = "richtext";
  ResourceCenterBlockType2["DIVIDER"] = "divider";
  ResourceCenterBlockType2["SUB_PAGE"] = "sub-page";
  ResourceCenterBlockType2["CONTENT_LIST"] = "content-list";
  ResourceCenterBlockType2["LIVE_CHAT"] = "live-chat";
  ResourceCenterBlockType2["ANNOUNCEMENT"] = "announcement";
  return ResourceCenterBlockType2;
})(ResourceCenterBlockType || {});
var LiveChatProvider = /* @__PURE__ */ ((LiveChatProvider2) => {
  LiveChatProvider2["CRISP"] = "crisp";
  LiveChatProvider2["CUSTOM"] = "custom";
  LiveChatProvider2["FRESHCHAT"] = "freshchat";
  LiveChatProvider2["HELP_SCOUT"] = "help-scout";
  LiveChatProvider2["HUBSPOT"] = "hubspot";
  LiveChatProvider2["INTERCOM"] = "intercom";
  LiveChatProvider2["ZENDESK_CLASSIC"] = "zendesk-classic";
  LiveChatProvider2["ZENDESK_MESSENGER"] = "zendesk-messenger";
  return LiveChatProvider2;
})(LiveChatProvider || {});

// src/types/announcement.ts
var AnnouncementDistribution = /* @__PURE__ */ ((AnnouncementDistribution2) => {
  AnnouncementDistribution2["SILENT"] = "silent";
  AnnouncementDistribution2["BADGE"] = "badge";
  AnnouncementDistribution2["POPUP"] = "popup";
  return AnnouncementDistribution2;
})(AnnouncementDistribution || {});
var AnnouncementPopupStyle = /* @__PURE__ */ ((AnnouncementPopupStyle2) => {
  AnnouncementPopupStyle2["MODAL"] = "modal";
  AnnouncementPopupStyle2["BUBBLE"] = "bubble";
  return AnnouncementPopupStyle2;
})(AnnouncementPopupStyle || {});

// src/types/team.ts
var TeamMemberRole = /* @__PURE__ */ ((TeamMemberRole2) => {
  TeamMemberRole2["ADMIN"] = "ADMIN";
  TeamMemberRole2["EDITOR"] = "EDITOR";
  TeamMemberRole2["VIEWER"] = "VIEWER";
  TeamMemberRole2["OWNER"] = "OWNER";
  return TeamMemberRole2;
})(TeamMemberRole || {});

// src/types/subscription.ts
var PlanType = /* @__PURE__ */ ((PlanType2) => {
  PlanType2["HOBBY"] = "hobby";
  PlanType2["STARTER"] = "starter";
  PlanType2["GROWTH"] = "growth";
  PlanType2["BUSINESS"] = "business";
  PlanType2["ENTERPRISE"] = "enterprise";
  return PlanType2;
})(PlanType || {});

// src/types/web-socket.ts
var WebSocketEvents = /* @__PURE__ */ ((WebSocketEvents2) => {
  WebSocketEvents2["SERVER_MESSAGE"] = "server-message";
  WebSocketEvents2["CLIENT_MESSAGE"] = "client-message";
  return WebSocketEvents2;
})(WebSocketEvents || {});
var ClientMessageKind = /* @__PURE__ */ ((ClientMessageKind2) => {
  ClientMessageKind2["UPSERT_USER"] = "UpsertUser";
  ClientMessageKind2["UPSERT_COMPANY"] = "UpsertCompany";
  ClientMessageKind2["TRACK_EVENT"] = "TrackEvent";
  ClientMessageKind2["START_CONTENT"] = "StartContent";
  ClientMessageKind2["END_CONTENT"] = "EndContent";
  ClientMessageKind2["GO_TO_STEP"] = "GoToStep";
  ClientMessageKind2["ANSWER_QUESTION"] = "AnswerQuestion";
  ClientMessageKind2["CLICK_CHECKLIST_TASK"] = "ClickChecklistTask";
  ClientMessageKind2["HIDE_CHECKLIST"] = "HideChecklist";
  ClientMessageKind2["SHOW_CHECKLIST"] = "ShowChecklist";
  ClientMessageKind2["UPDATE_CLIENT_CONTEXT"] = "UpdateClientContext";
  ClientMessageKind2["REPORT_TOOLTIP_TARGET_MISSING"] = "ReportTooltipTargetMissing";
  ClientMessageKind2["TOGGLE_CLIENT_CONDITION"] = "ToggleClientCondition";
  ClientMessageKind2["FIRE_CONDITION_WAIT_TIMER"] = "FireConditionWaitTimer";
  ClientMessageKind2["ACTIVATE_LAUNCHER"] = "ActivateLauncher";
  ClientMessageKind2["DISMISS_LAUNCHER"] = "DismissLauncher";
  ClientMessageKind2["TRACK_TRACKER_EVENT"] = "TrackTrackerEvent";
  ClientMessageKind2["OPEN_RESOURCE_CENTER"] = "OpenResourceCenter";
  ClientMessageKind2["CLOSE_RESOURCE_CENTER"] = "CloseResourceCenter";
  ClientMessageKind2["CLICK_RESOURCE_CENTER"] = "ClickResourceCenter";
  ClientMessageKind2["LIST_RESOURCE_CENTER_BLOCK_CONTENT"] = "ListResourceCenterBlockContent";
  ClientMessageKind2["LIST_ANNOUNCEMENTS"] = "ListAnnouncements";
  ClientMessageKind2["GET_ANNOUNCEMENT"] = "GetAnnouncement";
  ClientMessageKind2["MARK_ANNOUNCEMENTS_SEEN"] = "MarkAnnouncementsSeen";
  ClientMessageKind2["BEGIN_BATCH"] = "BeginBatch";
  ClientMessageKind2["END_BATCH"] = "EndBatch";
  ClientMessageKind2["END_ALL_CONTENT"] = "EndAllContent";
  return ClientMessageKind2;
})(ClientMessageKind || {});
var ServerMessageKind = /* @__PURE__ */ ((ServerMessageKind2) => {
  ServerMessageKind2["SET_FLOW_SESSION"] = "SetFlowSession";
  ServerMessageKind2["SET_CHECKLIST_SESSION"] = "SetChecklistSession";
  ServerMessageKind2["SET_BANNER_SESSION"] = "SetBannerSession";
  ServerMessageKind2["SET_RESOURCE_CENTER_SESSION"] = "SetResourceCenterSession";
  ServerMessageKind2["UNSET_FLOW_SESSION"] = "UnsetFlowSession";
  ServerMessageKind2["UNSET_CHECKLIST_SESSION"] = "UnsetChecklistSession";
  ServerMessageKind2["UNSET_BANNER_SESSION"] = "UnsetBannerSession";
  ServerMessageKind2["UNSET_RESOURCE_CENTER_SESSION"] = "UnsetResourceCenterSession";
  ServerMessageKind2["ADD_LAUNCHER"] = "AddLauncher";
  ServerMessageKind2["REMOVE_LAUNCHER"] = "RemoveLauncher";
  ServerMessageKind2["ADD_TRACKER"] = "AddTracker";
  ServerMessageKind2["REMOVE_TRACKER"] = "RemoveTracker";
  ServerMessageKind2["FORCE_GO_TO_STEP"] = "ForceGoToStep";
  ServerMessageKind2["TRACK_CLIENT_CONDITION"] = "TrackClientCondition";
  ServerMessageKind2["UNTRACK_CLIENT_CONDITION"] = "UntrackClientCondition";
  ServerMessageKind2["START_CONDITION_WAIT_TIMER"] = "StartConditionWaitTimer";
  ServerMessageKind2["CANCEL_CONDITION_WAIT_TIMER"] = "CancelConditionWaitTimer";
  ServerMessageKind2["CHECKLIST_TASK_COMPLETED"] = "ChecklistTaskCompleted";
  return ServerMessageKind2;
})(ServerMessageKind || {});

// src/types/editor.ts
var ContentEditorElementType = /* @__PURE__ */ ((ContentEditorElementType2) => {
  ContentEditorElementType2["TEXT"] = "text";
  ContentEditorElementType2["IMAGE"] = "image";
  ContentEditorElementType2["BUTTON"] = "button";
  ContentEditorElementType2["EMBED"] = "embed";
  ContentEditorElementType2["COLUMN"] = "column";
  ContentEditorElementType2["GROUP"] = "group";
  ContentEditorElementType2["NPS"] = "nps";
  ContentEditorElementType2["STAR_RATING"] = "star-rating";
  ContentEditorElementType2["SCALE"] = "scale";
  ContentEditorElementType2["SINGLE_LINE_TEXT"] = "single-line-text";
  ContentEditorElementType2["MULTI_LINE_TEXT"] = "multi-line-text";
  ContentEditorElementType2["MULTIPLE_CHOICE"] = "multiple-choice";
  return ContentEditorElementType2;
})(ContentEditorElementType || {});
var ContentEditorSideBarType = /* @__PURE__ */ ((ContentEditorSideBarType2) => {
  ContentEditorSideBarType2["TOP"] = "top";
  ContentEditorSideBarType2["RIGHT"] = "right";
  ContentEditorSideBarType2["BOTTOM"] = "bottom";
  return ContentEditorSideBarType2;
})(ContentEditorSideBarType || {});

// src/types/permission.ts
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["OWNER"] = "OWNER";
  Role2["ADMIN"] = "ADMIN";
  Role2["EDITOR"] = "EDITOR";
  Role2["VIEWER"] = "VIEWER";
  return Role2;
})(Role || {});
var Capability = /* @__PURE__ */ ((Capability2) => {
  Capability2["ContentRead"] = "content:read";
  Capability2["ContentCreate"] = "content:create";
  Capability2["ContentUpdate"] = "content:update";
  Capability2["ContentPublish"] = "content:publish";
  Capability2["ContentPublishAnyEnvironment"] = "content:publish-any-environment";
  Capability2["ContentDelete"] = "content:delete";
  Capability2["ThemeRead"] = "theme:read";
  Capability2["ThemeCreate"] = "theme:create";
  Capability2["ThemeUpdate"] = "theme:update";
  Capability2["ThemeDelete"] = "theme:delete";
  Capability2["AttributeRead"] = "attribute:read";
  Capability2["AttributeCreate"] = "attribute:create";
  Capability2["AttributeUpdate"] = "attribute:update";
  Capability2["AttributeDelete"] = "attribute:delete";
  Capability2["EventRead"] = "event:read";
  Capability2["EventCreate"] = "event:create";
  Capability2["EventUpdate"] = "event:update";
  Capability2["EventDelete"] = "event:delete";
  Capability2["LocalizationRead"] = "localization:read";
  Capability2["LocalizationCreate"] = "localization:create";
  Capability2["LocalizationUpdate"] = "localization:update";
  Capability2["LocalizationDelete"] = "localization:delete";
  Capability2["SegmentRead"] = "segment:read";
  Capability2["SegmentCreate"] = "segment:create";
  Capability2["SegmentUpdate"] = "segment:update";
  Capability2["SegmentDelete"] = "segment:delete";
  Capability2["UserRead"] = "user:read";
  Capability2["UserWrite"] = "user:write";
  Capability2["UserDelete"] = "user:delete";
  Capability2["CompanyRead"] = "company:read";
  Capability2["CompanyWrite"] = "company:write";
  Capability2["CompanyDelete"] = "company:delete";
  Capability2["SessionRead"] = "session:read";
  Capability2["SessionManage"] = "session:manage";
  Capability2["AnalyticsRead"] = "analytics:read";
  Capability2["AuditRead"] = "audit:read";
  Capability2["EnvironmentRead"] = "environment:read";
  Capability2["EnvironmentManage"] = "environment:manage";
  Capability2["AccessTokenRead"] = "accesstoken:read";
  Capability2["AccessTokenManage"] = "accesstoken:manage";
  Capability2["IntegrationRead"] = "integration:read";
  Capability2["IntegrationManage"] = "integration:manage";
  Capability2["WebhookRead"] = "webhook:read";
  Capability2["WebhookManage"] = "webhook:manage";
  Capability2["ProjectRead"] = "project:read";
  Capability2["ProjectActivate"] = "project:activate";
  Capability2["ProjectManage"] = "project:manage";
  Capability2["BillingRead"] = "billing:read";
  Capability2["BillingManage"] = "billing:manage";
  Capability2["TeamRead"] = "team:read";
  Capability2["TeamManage"] = "team:manage";
  Capability2["TeamTransferOwnership"] = "team:transfer-ownership";
  Capability2["SsoRead"] = "sso:read";
  Capability2["SsoManage"] = "sso:manage";
  return Capability2;
})(Capability || {});
export {
  AnnouncementDistribution,
  AnnouncementPopupStyle,
  AttributeBizTypes,
  AttributeDataType,
  AttributeWriteOperation,
  AvatarType,
  BannerEmbedPlacement,
  BizAttributeTypes,
  BizEvents,
  BuilderType,
  Capability,
  ChecklistCompletionOrder,
  ChecklistInitialDisplay,
  ClientMessageKind,
  CompanyAttributes,
  ContentActionsItemType,
  ContentConditionLogic,
  ContentDataType,
  ContentEditorElementType,
  ContentEditorSideBarType,
  ContentPriority,
  ContentTypeName,
  ElementConditionLogic,
  EventAttributes,
  EventCountLogic,
  EventScope,
  EventTimeLogic,
  EventTimeUnit,
  Frequency,
  FrequencyUnits,
  LauncherActionType,
  LauncherDataType,
  LauncherIconSource,
  LauncherPositionType,
  LauncherTriggerElement,
  LauncherTriggerEvent,
  LiveChatProvider,
  MissingTooltipTargetBehavior,
  ModalBackdropClickBehavior,
  ModalPosition,
  PlanType,
  ProgressBarPosition,
  ProgressBarType,
  ResourceCenterBlockType,
  Role,
  RulesType,
  SDKSettingsMode,
  SegmentDataTypes,
  ServerMessageKind,
  StepContentType,
  StringConditionLogic,
  TeamMemberRole,
  ThemeDetailPreviewType,
  UserAttributes,
  usertour_exports as UserTourTypes,
  WebSocketEvents,
  contentEndReason,
  contentStartReason
};
